/* eslint-disable import/prefer-default-export */
import * as Yup from 'yup';

export const SEND_PARTNER_INVITE_SCHEMA = Yup.object().shape({
  email: Yup.string().email('Please enter a valid email').required('Email is required'),
});
